// extracted by mini-css-extract-plugin
export default {"Icon":"JpU3XV14Xj5bdwq9UTbR"};